/**
 * Contain the Style for the Borrows View
 */

//ColorManager
import ColorManager from "./../managers/ColorManager";

export default {

    container: {
        position: "relative"
    },

    list: {
        backgroundColor: "#FFF",
        padding: 0
    },

    secondaryTextChildren: {
        display: "flex",
        flexDirection: "column"
    },

    validationButton: {
        backgroundColor: "#43A047",
        color: "#FFF"
    },

    iconMaterial: {
        backgroundColor: "rgba(255,255,255,0.4)"
    },

    iconComment: {
        color: ColorManager.secondaryText
    },

    damagedMaterial: {
        backgroundColor: ColorManager.error
    },

    undamagedMaterial: {
        backgroundColor: "#2FCF70"//"#33E07A"
    },

    cancelButton: {
        backgroundColor: "#E53935",
        color: "#FFF",
        fontWeight: "thin"
    },

    checkbox: {
        color: ColorManager.whiteTransparency90
    }
};



// WEBPACK FOOTER //
// ./src/app/styles/Borrows.ts